// Copyright (c) 2016 Deere & Company

import {
    resetCriteria,
    updateResponsibleDealerCriteria
} from './criteria';
import {selectAllDealersOnLoad, selectAllResponsibleDealers, selectResponsibleDealer} from './select-dealer';
import {createResponsibleReport} from './create-report';
import {sharedActionCreators} from '../../shared/action-creators';

export default {
    createResponsibleReport,
    resetCriteria,
    selectAllDealersOnLoad,
    selectAllResponsibleDealers,
    selectResponsibleDealer,
    updateResponsibleDealerCriteria,
    ...sharedActionCreators
};



// WEBPACK FOOTER //
// ./src/reports/responsible-dealer/action-creators/index.js